/**
 * @description: 团购套餐销售汇总报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="gsr-ttxh-report">
        <div class="ttxh-list">
            <p class="p-hint">注：统计的数据已扣除退货数量</p>
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="ttxhTime">
                        <input type="text" class="form-control laydate-icon" v-model="ttxhStartTime"> -
                        <input type="text" class="form-control laydate-icon" v-model="ttxhEndTime">
                    </div>
                </div>
                <label class="list-label-4">消费门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="ttxh_shop" data-placeholder="请选择消费门店"></select>
                </div>
                <label class="list-label-6">团购套餐名称:</label>
                <div class="col-md-2">
                    <input type="text" class="form-control" v-model="ttxh_name" placeholder="请输入团购套餐名称">
                </div>
                <label class="list-label-4">团购来源:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="ttxh_from" data-placeholder="请选择团购来源"></select>
                </div>
            </div>
            <div class="row">
                <label class="list-label-4">销售总量:</label>
                <div class="list-total" ref="ttxh_xs_total"></div>
                <label class="list-label-4">销售总额:</label>
                <div class="list-total" ref="ttxh_xs_amount"></div>
                <div class="pull-right">
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="innitTtxhTable" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getTtxhExportSet">导出</button>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="ttxhList"></table>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="ttxhExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='ttxhExport_allcheck' @click='ttxhExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ttxhExport_checkModel' value="shop_name">
                            <label>门店</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ttxhExport_checkModel' value="group_type_name">
                            <label>团购来源</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ttxhExport_checkModel' value="package_name">
                            <label>团购套餐名称</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ttxhExport_checkModel' value="quantity">
                            <label>销售总量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ttxhExport_checkModel' value="price">
                            <label>销售单价</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ttxhExport_checkModel' value="amount_total">
                            <label>销售总额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ttxhExport_checkModel' value="settlemen_total">
                            <label>团购结算价总额</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='ttxhExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='ttxhExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                ttxhStartTime: "",
                ttxhEndTime: "",
                ttxh_name: '',
                ttxhExport_allcheck: false,
                c_ttxhExport_allcheck: false,
                ttxhExport_checkModel: [],
                ttxhExport_checkData: ['shop_name', 'group_type_name', 'package_name', 'quantity', 'price', 'amount_total', 'settlemen_total'],
                ttxhExport_type: 1,
            }
        },
        watch: {
            ttxhExport_checkModel: {
                handler: function(val, oldVal) {
                    if(this.ttxhExport_checkModel.length >= this.ttxhExport_checkData.length) {
                        this.ttxhExport_allcheck = true;
                        this.c_ttxhExport_allcheck = true;
                    } else {
                        this.ttxhExport_allcheck = false;
                        this.c_ttxhExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            // 日期
            this.ttxhStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.ttxhEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.innitDate(); // 日期
            this.shopDatas = [];
            this.innitInput();  // 门店
            // 团购来源
            $(this.$refs.ttxh_from).select2({
                minimumResultsForSearch: -1,
                language: "zh-CN",
                width: '100%'
            });
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.ttxhStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.ttxhEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.ttxhStartTime = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.ttxhEndTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.ttxhTime).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                    dateLimit: {
                        days: 31
                    },
                }, function(start, end, label) {
                    _this.ttxhStartTime = start.format('YYYY-MM-DD HH:mm');
                    _this.ttxhEndTime = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 初始化门店输入框
            innitInput: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                _this.shopDatas.push({
                                    id: v.id,
                                    text: v.name
                                });
                            });
                            $(_this.$refs.ttxh_shop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                _this.setShopDefaultTime(e.params.data.id);
                                _this.getShopGroupType(e.params.data.id);
                            });
                            $(_this.$refs.ttxh_shop).val(data.response.result[1].id).trigger('change');
                            _this.setShopDefaultTime(data.response.result[1].id);
                            _this.getShopGroupType(data.response.result[1].id);
                            _this.innitTtxhTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },

            // 获取团购来源类型
            getShopGroupType: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopGroup",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result']['result'], function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.ttxh_from).html("");
                            $(_this.$refs.ttxh_from).select2({
                                data: arr,
                                language: "zh-CN",
                                width: '100%'
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },

            // 表格
            innitTtxhTable: function() {
                let _this = this;
                $(_this.$refs.ttxhList).bootstrapTable('destroy');
                $(_this.$refs.ttxhList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getTtxhList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "index",
                        title: "行号",
                        width: "5%",
                        valign: "middle",
                        formatter: function(value, row, index) {
                            return index + 1;
                        }
                    }, {
                        field: "shop_name",
                        title: "门店",
                        width: "8%",
                        valign: "middle"
                    }, {
                        field: "group_type_name",
                        title: "团购来源",
                        width: "5%",
                        valign: "middle"
                    }, {
                        field: "package_name",
                        title: "团购套餐名称",
                        width: "8%",
                        valign: "middle"
                    }, {
                        field: "quantity",
                        title: "销售总量",
                        width: "5%",
                        valign: "middle"
                    }, {
                        field: "price",
                        title: "销售单价",
                        width: "5%",
                        valign: "middle"
                    }, {
                        field: "amount_total",
                        title: "销售总额",
                        width: "5%",
                        valign: "middle"
                    }, {
                        field: "settlemen_total",
                        title: "团购结算价<br />总额",
                        width: "5%",
                        valign: "middle"
                    }],
                });
            },
            getTtxhList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "start_time": _this.ttxhStartTime,
                            "end_time": _this.ttxhEndTime,
                            "shop_id": $(_this.$refs.ttxh_shop).val(),
                            "group_type": $.trim($(_this.$refs.ttxh_from).val()),
                            "package_name": _this.ttxh_name
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + 'FinanceReport2/getGroupPackageSummary',
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.total,
                                rows: data.response.result.rows
                            });
                            $(_this.$refs.ttxh_xs_total).text(data.response.result.quantity_total);
                            $(_this.$refs.ttxh_xs_amount).text(data.response.result.amount_total);
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取导出设置
            getTtxhExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport2/groupSaledSummaryExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.ttxhExport_checkModel = data.response.result.export_fields;
                                _this.ttxhExport_type = data.response.result.export_type;
                            } else {
                                _this.ttxhExport_checkModel = _this.ttxhExport_checkData;
                                _this.ttxhExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.ttxhExport_alert)
                }, function() {
                    _this.exportTtxhList();
                });
            },
            // 导出字段全选
            ttxhExportCheckedAll: function(type) {
                let _this = this;
                _this.ttxhExport_allcheck = _this.c_ttxhExport_allcheck;
                if(!_this.ttxhExport_allcheck) { // 实现全选
                    _this.ttxhExport_checkModel = [];
                    _this.ttxhExport_checkData.forEach(function(item) {
                        _this.ttxhExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.ttxhExport_checkModel = [];
                }
            },
            // 点击“导出”按钮
            exportTtxhList: function() {
                let _this = this;

                let export_fields = JSON.stringify(_this.ttxhExport_checkModel);
                window.location.href = Vue.ctUrl + "FinanceReport2/groupSaledSummaryExport" +
                    "?start_time=" + _this.ttxhStartTime +
                    "&end_time=" + _this.ttxhEndTime +
                    "&shop_id=" + $(_this.$refs.ttxh_shop).val() +
                    "&group_type=" + $.trim($(_this.$refs.ttxh_from).val()) +
                    "&package_name=" + _this.ttxh_name +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.ttxhExport_type;
                // debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
        }
    }
</script>
<style lang="less" scoped>
    
</style>